var canvas = '';
var canvasorig = '';
var CanvasSettings = {};
CanvasSettings.fh_left = 38;
CanvasSettings.fh_top = 100;
CanvasSettings.fh_width = 0.6;
CanvasSettings.fh_fontsize = 40;
CanvasSettings.in_fontsize = 21;
CanvasSettings.objWidth = 50;
CanvasSettings.object_scale = 0.18;
CanvasSettings.centerWidthVariation = 40;
CanvasSettings.img_top = 60;
CanvasSettings.in_width = 200;

jQuery(document).ready(function($){
  	
  	$.getJSON('/cart.js', function(cart){ 
      // console.log(cart);
      var counter = 1;
      if (localStorage.getItem('counter') !== null) {
        counter = parseInt(localStorage.getItem('counter'));
      }
      if (localStorage.getItem('svgimgnew') !== null) {
      	localStorage.setItem('svgcode'+(counter), localStorage.getItem('svgimgnew'));  
        // console.log(cart.items[0].key);
        localStorage.setItem(cart.items[0].key,'svgcode'+(counter));  
        localStorage.removeItem('svgimgnew');
        localStorage.setItem('counter',++counter);  
      }
      
    });
  	
    $(document).on('click','.product-minus',function(){
      if($(this).closest('.mini-cart__item').find('.quantity').val() == 0){
        var lineid = $(this).closest('.mini-cart__item').attr('data-line-id');
        $.getJSON('/cart.js', function(cart){           
          // console.log(cart.items[(lineid-1)].key);
          if (localStorage.getItem((cart.items[(lineid-1)].key)) !== null) {
            
            	// console.log('Keychain Product Removed');
            
            	localStorage.removeItem(localStorage.getItem((cart.items[(lineid-1)].key)));
            	localStorage.removeItem(cart.items[(lineid-1)].key);
          }

        });
      }
      console.log("QTY:"+$(this).closest('.mini-cart__item').find('.quantity').val());
    });
  	
  	$(document).on('click','.cart__remove-btn',function(){
      
      var lineid = $(this).closest('.mini-cart__item').attr('data-line-id');
      $.getJSON('/cart.js', function(cart){           
        // console.log(cart.items[(lineid-1)].key);
        if (localStorage.getItem((cart.items[(lineid-1)].key)) !== null) {

          // console.log('Keychain Product Removed');

          localStorage.removeItem(localStorage.getItem((cart.items[(lineid-1)].key)));
          localStorage.removeItem(cart.items[(lineid-1)].key);
        }

      });
      // console.log("QTY:"+$(this).closest('.mini-cart__item').find('.quantity').val());
    });
  
	if($('#canvas').length > 0){
      	var totalCount = '';
       
      	jQuery(document).on('click','.add_to_cart',function(){
          
	        var svgimg = canvasorig.toSVG({suppressPreamble: true,encoding: 'ISO-8859-1'});
            $.getJSON('/cart.js', function(cart){ 
                  localStorage.setItem('svgimgnew', svgimg);
          	});
	        
	    });


		if(window.innerWidth < 420){
			//var width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
          	var width = $('.product_gallery ').width();
			var canvasElement = document.getElementById("canvas");
			canvasElement.width = width;
			canvasElement.height = width;	
			CanvasSettings.fh_left = 20;
			CanvasSettings.fh_top = 60;
			CanvasSettings.fh_width = 0.6;
			CanvasSettings.fh_fontsize = 22;
			CanvasSettings.in_fontsize = 10;
			CanvasSettings.objWidth = 20;
			CanvasSettings.in_width = 100;
			
			CanvasSettings.centerWidthVariation = 15;

			CanvasSettings.object_scale = 0.09;
			CanvasSettings.img_top = 35;
          
		}else if(window.innerWidth < 992){
			var width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
			var canvasElement = document.getElementById("canvas");
			canvasElement.width = width-15;
			canvasElement.height = width-15;	
			CanvasSettings.fh_left = 20;
			CanvasSettings.fh_top = 120;
			CanvasSettings.fh_width = 0.6;
			CanvasSettings.fh_fontsize = 60;
			CanvasSettings.in_fontsize = 26;
			CanvasSettings.objWidth = 20;
			CanvasSettings.in_width = 100;
			
			CanvasSettings.centerWidthVariation = 25;

			CanvasSettings.object_scale = 0.22;
			CanvasSettings.img_top = 35;
          
		}else if(window.innerWidth < 1025){
			
			// var width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
			var width = $('.product_gallery ').width();
			var canvasElement = document.getElementById("canvas");
			canvasElement.width = width-15;
			canvasElement.height = width-15;	
			CanvasSettings.fh_left = 20;
			CanvasSettings.fh_top = 70;
			CanvasSettings.fh_width = 0.6;
			CanvasSettings.fh_fontsize = 30;
			CanvasSettings.in_fontsize = 14;
			CanvasSettings.objWidth = 20;
			CanvasSettings.in_width = 100;
			
			CanvasSettings.centerWidthVariation = 25;

			CanvasSettings.object_scale = 0.13;
			CanvasSettings.img_top = 35;	
		}

		canvas = new fabric.Canvas('canvas');
		canvasorig = new fabric.Canvas('canvasorig');		
      	var widthtemp = canvas.getWidth();
		// console.log(widthtemp);
		fabric.fontPaths['moon'] = 'http://cdn.shopify.com/s/files/1/0477/7115/6643/t/7/assets/MOON-FLOWER-BOLD.ttf';
		var centerpoint = canvas.getCenter();
		var centerpointorig = canvasorig.getCenter();

		// var img = "./images/keychain.png";
		// var imgorig = "./images/keychaindesign.png";

		var img = "//bellamiaboutique.nl/cdn/shop/t/56/assets/keychain.png?v=157284372052889613981763070420";
		var imgorig = "//bellamiaboutique.nl/cdn/shop/t/56/assets/keychaindesign.png?v=24325";
		
		fabric.Image.fromURL(img, function(img) {
		    canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas), {
		       scaleX: canvas.width / img.width,
		       scaleY: canvas.height / img.height
		    });
		},{ crossOrigin: 'anonymous'});

		
		heading = new fabric.Textbox('', {
		  fontSize: CanvasSettings.fh_fontsize,
		  fontFamily: 'moon',
		  left: centerpoint.left + CanvasSettings.fh_left,
		  top: centerpoint.top - CanvasSettings.fh_top,
		  originX:'center',
		  textAlign: 'center',
		  selectable: false,
		  splitByGrapheme:true, 
		  width:(canvas.getWidth() * CanvasSettings.fh_width),
		  id:'heading',
		  maxlength:24
		});
		canvas.add(heading);

		headingOrig = new fabric.Textbox('', {
		  fontSize: 13,
		  fontFamily: 'moon',
		  top: 7,
		  left: 71,
		  textAlign: 'center',
		  selectable: false,
		  id:'headingorig',
		  width:(canvasorig.getWidth()),
		  maxlength:24,
		  charSpacing:-50,
		});
		canvasorig.add(headingOrig);
		headingOrig.centerH();
		
		headingOrig.set({
	    	left:headingOrig.left + 3
	    });
		
		canvasorig.renderAll();

		$('.typeuser-tab').on('click',function(){

			if($(this).hasClass('active')){
				$('.listtab').removeClass('active');
				$('.typeuser-tab').removeClass('active');
			}else{
				var tabId = $(this).attr('data-id');
				$('.listtab').removeClass('active');
				$('#tab-'+tabId).addClass('active');

				$('.typeuser-tab').removeClass('active');
				$(this).addClass('active');
			}
			
		});

		$('#objtextfield').sortable({
			handle: ".moveobj",
			update: function( event, ui ) {
              // console.log('Obj1');
				SortObjects();
			}
		});
		
		$('button.image').on('click',function(){
			if(canvas.getObjects('image').length < 6){  	

				var type = $(this).data('type');
				var objId = GenerateObjectBox(type);
				addObject($(this).data('img'),objId+'-text',objId+'-img', 1, 1);
				addObjectOriginal($(this).data('img'),objId+'-text',objId+'-img', 0.5, 0.85);

			}else{
				$('.keychain-wrapper').find('.maxitem_err').remove();
				$('.keychain-wrapper').find('.headingtext-wrapper').append( "<span class='maxitem_err'>Sorry, je kunt maximaal 6 familieleden toevoegen.</span>" );

			}
          
          	$('.typeuser-tab.active').removeClass('active');
			$('.listtab.active').removeClass('active');
          
		});

		$(document).on('click','span.removeobj',function(){

			var objId = $(this).closest('.objwrapper').attr('data-id');
			var textobj = canvas.removeItem(objId+'-text');
			var imgobj = canvas.removeItem(objId+'-img');
			canvas.renderAll();

			
			var obj22 = canvasorig.getItem(objId+'-text');	

			var textobj = canvasorig.removeItem(objId+'-text');
			var imgobj = canvasorig.removeItem(objId+'-img');
			canvasorig.renderAll();


			$('#box-'+objId).remove();
			SetAllObjectHorizontally();
			SetAllOrigionalObjectHorizontally();

		});

		$('.headingtextobj').on('keyup',function(){
			var name = $(this).val();
			var valLength = name.length;
			if( valLength > 24 ){
				$(this).val($(this).val().substr(0, 24));
		        return '';
		    }else{
			
				objId = $(this).attr('id');
				var obj = canvas.getItem(objId);
				obj.text = name;
				canvas.renderAll();

				var objOrig = canvasorig.getItem('headingorig');
				objOrig.text = name;
				canvasorig.renderAll();
			}

		});

		$('#tosvg').on('click',function(){
			var svg = canvasorig.toSVG({suppressPreamble: true,encoding: 'ISO-8859-1'});
			// console.log(svg);
		});

	}
});

function addObject(imageName,textobj, imgobj, minScale, maxScale) {
	var imgID = imgobj;

	var centerpoint = canvas.getCenter();
	
	fabric.Image.fromURL(imageName, function(imgobj) {
		window[textobj] = '';
	    window[textobj] = new fabric.Textbox('Name', {
	      fontSize: CanvasSettings.in_fontsize,
	      left: 0,
	      top: imgobj.height + centerpoint.top,
	      originX:'center',
	      textAlign: 'center',
          selectable: false,
          id:textobj,
          splitByGrapheme:true, 
          width:CanvasSettings.in_width,
          fontFamily: 'moon',
          lineHeight : 0.8,
	    });
	    
	    canvas.add(window[textobj]);
	    imgobj.set({
	      left: 0,
	      top: centerpoint.top - CanvasSettings.img_top,
	      originX:'center',
	      selectable: false,
          id:imgID,
          // strokeWidth:1,
          // stroke:'red'
	    })
	    .scale(CanvasSettings.object_scale)
	    .setCoords();
	    
	    
	    canvas.add(imgobj);
	    window[textobj].set({
	    	top:imgobj.getScaledHeight() + centerpoint.top - CanvasSettings.img_top
	    });
	    
	    canvas.renderAll();

	    $('.objname').on('keyup',function(){
	    	var name = $(this).val();
	    	objId = $(this).attr('id');
	    	var obj = canvas.getItem(objId+'-text');
	    	obj.text = name;
	    	canvas.renderAll();
	    });
	    SetAllObjectHorizontally();

	});
};



function addObjectOriginal(imageName,textobj, imgobj, minScale, maxScale) {
	var imgID = imgobj;
	var centerpoint = canvasorig.getCenter();

	fabric.Image.fromURL(imageName, function(imgobj) {
		textobjOrig = '';
	    textobjOrig = new fabric.Textbox('Name', {
	      fontSize: 7.5,
	      left: 0,
	      top: imgobj.height + centerpoint.top - 30,
	      originX:'center',
	      textAlign: 'center',
          selectable: false,
          id:textobj,
          splitByGrapheme:true, 
          width:CanvasSettings.in_width,
          fontFamily: 'moon',
          lineHeight : 0.8,
          charSpacing:-50,
	    });
	    
	    canvasorig.add(textobjOrig);
	    imgobj.set({
	      left: 0,
	      top: centerpoint.top - 24,
	      originX:'center',
	      selectable: false,
          id:imgID,
          // strokeWidth:1,
          // stroke:'red'
	    })
	    .scale(0.054)
	    .setCoords();	    
	    canvasorig.add(imgobj);

	    textobjOrig.set({
	    	top:imgobj.getScaledHeight() + centerpoint.top - 24
	    });
	    
	    canvasorig.renderAll();

	    $('.objname').on('keyup',function(){
	    	var name = $(this).val();
	    	objId = $(this).attr('id');
	    	var obj = canvasorig.getItem(objId+'-text');
	    	obj.text = name;
	    	canvasorig.renderAll();
	    });

	    SetAllOrigionalObjectHorizontally();

	},{ crossOrigin: 'anonymous'});
};


function SetAllObjectHorizontally () {

	var totalImg = canvas.getObjects('image').length;
	var centerpoint = canvas.getCenter();
	var centerWidth = centerpoint.left + CanvasSettings.centerWidthVariation;

	var objWidthArr = {};
	var i = 1;
	canvas.forEachObject(function(obj){
		if(obj.isType('image')){
			objWidthArr[i] = obj.getScaledWidth();
			i++;
		}
	});
	var textwidth = '';
	var objcount = 1;
	canvas.forEachObject(function(obj){	
			textwidth = objWidthArr[objcount];
			if(totalImg == 1){				
				obj.set({
		            left : (centerWidth),
		        });
			}else if(totalImg == 2){
				if(objcount == 1){
					obj.set({
			            left : (centerWidth - (parseInt(objWidthArr[1])/2) - 2.5),
			        });

				}else if(objcount == 2){
					obj.set({
			            left : (centerWidth + (parseInt(objWidthArr[2])/2) + 2.5),
			        });
				}
			}else if(totalImg == 3){
				if(objcount == 1){
					obj.set({
			            left : (centerWidth - (parseInt(objWidthArr[2])/2) - (parseInt(objWidthArr[1])/2) - 5),
			        });
				}else if(objcount == 2){
					obj.set({
			            left : centerWidth,
			        });
				}else if(objcount == 3){
					obj.set({
			            left : (centerWidth + (parseInt(objWidthArr[2])/2) + (parseInt(objWidthArr[3])/2) + 5),
			        });
				}
			}else if(totalImg == 4){
				if(objcount == 1){
					obj.set({
			            left : (centerWidth - parseInt(objWidthArr[2]) - (parseInt(objWidthArr[1])/2) - 7.5),
			        });

				}else if(objcount == 2){
					obj.set({
			            left : (centerWidth - (parseInt(objWidthArr[2])/2) - 2.5 ),
			        });
				}else if(objcount == 3){
					obj.set({
			            left : (centerWidth + (parseInt(objWidthArr[3])/2) + 2.5 ),
			        });
				}else if(objcount == 4){
					obj.set({
			            left : (centerWidth + parseInt(objWidthArr[3]) + (parseInt(objWidthArr[4])/2) + 7.5),
			        });
				}
			}else if(totalImg == 5){
				if(objcount == 1){
					obj.set({
			            left : (centerWidth - (parseInt(objWidthArr[3])/2) - (parseInt(objWidthArr[2])) - (parseInt(objWidthArr[1])/2) - 10),
			        });

				}else if(objcount == 2){
					obj.set({
			            left : (centerWidth - (parseInt(objWidthArr[3])/2) - (parseInt(objWidthArr[2])/2) - 5),
			        });
				}else if(objcount == 3){
					obj.set({
			            left : centerWidth,
			        });
				}else if(objcount == 4){
					obj.set({
			            left : (centerWidth + (parseInt(objWidthArr[3])/2) + (parseInt(objWidthArr[4])/2) + 5),
			        });
				}else if(objcount == 5){
					obj.set({
			            left : (centerWidth + (parseInt(objWidthArr[3])/2) + (parseInt(objWidthArr[4])) + (parseInt(objWidthArr[5])/2) + 10),
			        });
				}
			}else if(totalImg == 6){
				if(objcount == 1){
					obj.set({
			            left : (centerWidth - parseInt(objWidthArr[3]) - parseInt(objWidthArr[2]) - (parseInt(objWidthArr[1])/2) - 12.5),
			        });

				}else if(objcount == 2){
					obj.set({
			            left : (centerWidth - parseInt(objWidthArr[3]) - (parseInt(objWidthArr[2])/2) - 7.5),
			        });
				}else if(objcount == 3){
					obj.set({
			            left : (centerWidth - (parseInt(objWidthArr[3])/2) - 2.5 ),
			        });
				}else if(objcount == 4){
					obj.set({
			            left : (centerWidth + (parseInt(objWidthArr[4])/2) + 2.5 ),
			        });
				}else if(objcount == 5){
					obj.set({
			            left : (centerWidth + parseInt(objWidthArr[4]) + (parseInt(objWidthArr[5])/2) + 7.5),
			        });
				}else if(objcount == 6){
					obj.set({
			            left : (centerWidth + parseInt(objWidthArr[4]) + parseInt(objWidthArr[5]) + (parseInt(objWidthArr[6])/2) + 12.5),
			        });
				}
			}

	        if(obj.isType('textbox')){	
				obj.set({
		            width : textwidth,
		        });
	        }
			if(obj.isType('image')){	
				objcount++;
			}
			obj.setCoords();
	});
	
	var headingobj = canvas.getItem('heading');
	var centerpoint = canvas.getCenter();
	headingobj.set({
        left : (centerpoint.left + CanvasSettings.fh_left),
        width:(canvas.getWidth() * CanvasSettings.fh_width),
    });
	canvas.calcOffset();
	canvas.renderAll();

}

function SetAllOrigionalObjectHorizontally () {

	var totalImg = canvasorig.getObjects('image').length;
	var centerpoint = canvasorig.getCenter();
	var centerWidth = centerpoint.left + 5;

	var objWidthArr = {};
	var i = 1;
	canvasorig.forEachObject(function(obj){
		if(obj.isType('image')){
			objWidthArr[i] = obj.getScaledWidth();
			i++;
		}
	});


	var textwidth = '';
	var objcount = 1;
	canvasorig.forEachObject(function(obj){	
			textwidth = objWidthArr[objcount];
			if(totalImg == 1){
				obj.set({
			        left : (centerWidth),
			    });
			}else if(totalImg == 2){
				if(objcount == 1){
					obj.set({
			            left : (centerWidth - (parseInt(objWidthArr[1])/2) - 0.5),
			        });

				}else if(objcount == 2){
					obj.set({
			            left : (centerWidth + (parseInt(objWidthArr[2])/2) + 0.5),
			        });
				}
			}else if(totalImg == 3){
				if(objcount == 1){
					obj.set({
			            left : (centerWidth - (parseInt(objWidthArr[2])/2) - (parseInt(objWidthArr[1])/2) - 1),
			        });
				}else if(objcount == 2){
					obj.set({
			            left : centerWidth,
			        });
				}else if(objcount == 3){
					obj.set({
			            left : (centerWidth + (parseInt(objWidthArr[2])/2) + (parseInt(objWidthArr[3])/2) + 1),
			        });
				}
			}else if(totalImg == 4){
				if(objcount == 1){
					obj.set({
			            left : (centerWidth - parseInt(objWidthArr[2]) - (parseInt(objWidthArr[1])/2) - 1.5),
			        });

				}else if(objcount == 2){
					obj.set({
			            left : (centerWidth - (parseInt(objWidthArr[2])/2) - 0.5 ),
			        });
				}else if(objcount == 3){
					obj.set({
			            left : (centerWidth + (parseInt(objWidthArr[3])/2) + 0.5 ),
			        });
				}else if(objcount == 4){
					obj.set({
			            left : (centerWidth + parseInt(objWidthArr[3]) + (parseInt(objWidthArr[4])/2) + 1.5),
			        });
				}
			}else if(totalImg == 5){
				if(objcount == 1){
					obj.set({
			            left : (centerWidth - (parseInt(objWidthArr[3])/2) - (parseInt(objWidthArr[2])) - (parseInt(objWidthArr[1])/2) - 2),
			        });

				}else if(objcount == 2){
					obj.set({
			            left : (centerWidth - (parseInt(objWidthArr[3])/2) - (parseInt(objWidthArr[2])/2) - 1),
			        });
				}else if(objcount == 3){
					obj.set({
			            left : centerWidth,
			        });
				}else if(objcount == 4){
					obj.set({
			            left : (centerWidth + (parseInt(objWidthArr[3])/2) + (parseInt(objWidthArr[4])/2) + 1),
			        });
				}else if(objcount == 5){
					obj.set({
			            left : (centerWidth + (parseInt(objWidthArr[3])/2) + (parseInt(objWidthArr[4])) + (parseInt(objWidthArr[5])/2) + 2),
			        });
				}
			}else if(totalImg == 6){
				if(objcount == 1){
					obj.set({
			            left : (centerWidth - parseInt(objWidthArr[3]) - parseInt(objWidthArr[2]) - (parseInt(objWidthArr[1])/2) - 2.5),
			        });

				}else if(objcount == 2){
					obj.set({
			            left : (centerWidth - parseInt(objWidthArr[3]) - (parseInt(objWidthArr[2])/2) - 1.5),
			        });
				}else if(objcount == 3){
					obj.set({
			            left : (centerWidth - (parseInt(objWidthArr[3])/2) - 0.5 ),
			        });
				}else if(objcount == 4){
					obj.set({
			            left : (centerWidth + (parseInt(objWidthArr[4])/2) + 0.5 ),
			        });
				}else if(objcount == 5){
					obj.set({
			            left : (centerWidth + parseInt(objWidthArr[4]) + (parseInt(objWidthArr[5])/2) + 1.5),
			        });
				}else if(objcount == 6){
					obj.set({
			            left : (centerWidth + parseInt(objWidthArr[4]) + parseInt(objWidthArr[5]) + (parseInt(objWidthArr[6])/2) + 2.5),
			        });
				}
			}

        if(obj.isType('textbox')){	
			obj.set({
	            width : textwidth,
	        });
        }
		if(obj.isType('image')){	
			objcount++;
		}
		obj.setCoords();
	});
	var headingobj = canvasorig.getItem('headingorig');
	var centerpoint = canvasorig.getCenter();
	headingobj.set({
        width:(canvasorig.getWidth()),
    });
    headingobj.centerH();
	headingOrig.set({
		left:headingOrig.left + 3
	});
	canvasorig.renderAll();
}


function IncreaseObjCounter() {
	var counter = parseInt($('#objcounter').val());
	$('#objcounter').val(counter+1);
}

function GenerateObjectBox(type) {
	IncreaseObjCounter();
	var counter = parseInt($('#objcounter').val());
	var objId = 'obj'+counter;

	var objbox = $('.objectboxtemplate').html();
	objbox  = objbox.replace(/#ID#/g, objId);
	objbox  = objbox.replace(/#TYPE#/g, type);
	$('#objtextfield').append(objbox);
	$('#objtextfield').sortable({
      handle: ".moveobj",
      update: function( event, ui ) {
        SortObjects();
      }
    });
  	$('#'+objId).focus();
	return objId;
}

function SortObjects() {
console.log('sortobjfn');
	var counter = 1;
	$('#objtextfield > .objwrapper').each(function( index ) {
		var id = $(this).attr('data-id');
		
		var objtext = canvas.getItem(id+'-text');
		objtext.moveTo(counter);

		var objtextOrig = canvasorig.getItem(id+'-text');
		objtextOrig.moveTo(counter);
		counter++;	


		var objimg = canvas.getItem(id+'-img');
		objimg.moveTo(counter);

		var objimgOrig = canvasorig.getItem(id+'-img');
		objimgOrig.moveTo(counter);
		counter++;		

	});
	canvas.renderAll();
	canvasorig.renderAll();
    SetAllObjectHorizontally();
    SetAllOrigionalObjectHorizontally();
}
